export default {
  'WidgetIpotekaCalc': () => import('./form/ipoteka/calc.vue'),
  'Galery': () => import('./galery/Galery.vue'),
}
